import { render } from "./aLableRowId.vue?vue&type=template&id=bf697d1c"
import script from "./aLableRowId.vue?vue&type=script&lang=js"
export * from "./aLableRowId.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__